<div class="login-container">
  <div class="card-container">
    <div class="login-card">
      <img
        src="../../../../assets/images/AllyLogoDark.svg"
        alt="AndDone Ally"
        class="anddone-logo"
      />
      <h5>{{ 'changePassword.title' | translate }}</h5>
      <p>{{ 'changePassword.ruleHeading' | translate }}</p>
      <ul>
        <li>
          <img src="../../../../../assets/images/Warning.svg" alt="warning icon" />
          {{ 'changePassword.passwordRule1' | translate }}
        </li>
        <li>
          <img src="../../../../../assets/images/Warning.svg" alt="warning icon" />
          {{ 'changePassword.passwordRule2' | translate }}
        </li>
        <li>
          <img src="../../../../../assets/images/Warning.svg" alt="warning icon" />
          {{ 'changePassword.passwordRule3' | translate }}
        </li>
        <li>
          <img src="../../../../../assets/images/Warning.svg" alt="warning icon" />
          {{ 'changePassword.passwordRule4' | translate }}
        </li>
        <li>
          <img src="../../../../../assets/images/Warning.svg" alt="warning icon" />
          {{ 'changePassword.passwordRule5' | translate }}
        </li>
      </ul>
      <form novalidate [formGroup]="changePasswordForm">
        <div class="input-container">
          <label for="newPassword">
            <span class="required">*</span> {{ 'changePassword.newPassword' | translate }}
          </label>
          <input
            [type]="newPassFieldType"
            id="newPassword"
            placeholder="*********"
            formControlName="newPassword"
          />
          <i
            class="bi"
            [ngClass]="
              newPassFieldType === 'password'
                ? 'bi-eye-slash hide-password'
                : 'bi-eye show-password'
            "
            (click)="onTogglePassword('newPass')"
            tabindex="0"
            (keydown.enter)="onTogglePassword('newPass')"
          ></i>
          <span class="error-text">
            <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
              changePasswordFormErrors.newPassword
            }}
          </span>
        </div>
        <div class="input-container">
          <label for="confirmPassword">
            <span class="required">*</span> {{ 'changePassword.confirmNewPassword' | translate }}
          </label>
          <input
            [type]="confirmPassFieldType"
            id="confirmPassword"
            placeholder="*********"
            formControlName="confirmPassword"
          />
          <i
            class="bi"
            [ngClass]="
              confirmPassFieldType === 'password'
                ? 'bi-eye-slash hide-password'
                : 'bi-eye show-password'
            "
            (click)="onTogglePassword('confirmPass')"
            tabindex="0"
            (keydown.enter)="onTogglePassword('confirmPass')"
          ></i>
          <span class="error-text">
            <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
              changePasswordFormErrors.confirmPassword
            }}
          </span>
        </div>
        <div class="button-container d-flex justify-content-around align-items-center gap-3">
          <a
            class="button button-green"
            (click)="executeRecaptcha()"
            [ngStyle]="{ 'pointer-events': isLoader() ? 'none' : '' }"
          >
            <span>
              @if (isLoader()) {
                <span class="spinner-border spinner-border-sm"></span>
              }
              <span class="m-3">{{ 'changePassword.title' | translate }}</span>
            </span>
          </a>
        </div>
      </form>
    </div>
    <div class="login-footer">
      <span
        >{{ 'footer.copyrightText1' | translate }} {{ currentYear }}
        {{ 'footer.copyrightText2' | translate }}</span
      >
      <a (click)="goToLink(appSetting.privacyPolicyUrl)" target="currentwindow1">{{
        'footer.privacyStatement' | translate
      }}</a>
      <a (click)="goToLink(appSetting.termsOfUseUrl)" target="currentwindow2">{{
        'footer.termsOfService' | translate
      }}</a>
    </div>
  </div>
</div>
